<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="filter">
      <div class="title">
        <div class="titleLabel">{{'SHIPMENT_DASHBOARD.title' | translate}}</div>
        <div class="help">
          <app-help [helpData]="helpData"></app-help>
        </div>
      </div>
      <div class="input-container">
          <input (keyup)="searchDo($event.target.value)" [placeholder]="'SHIPMENT_DASHBOARD.searchDoNum' | translate" [(ngModel)]="do_no"
            class="inputSelect">
        <div class="buttons" (click)="toggle();">
          <div class="mapView mat-elevation-z4" *ngIf="!showAdvanceSearch" style="width: 160px;">
            <div style="padding: 4px;">
              {{'SHIPMENT_DASHBOARD.advancedSearch' | translate}}
            </div>
          </div>
          <div class="mapView mat-elevation-z4" *ngIf="showAdvanceSearch" style="width: 190px;">
            <div style="padding: 4px;">
              {{'SHIPMENT_DASHBOARD.closeAdvancedSearch' | translate}}
            </div>
          </div>
        </div>
        <div class="buttons" style="padding-left: 90px;">
          <div class="mapView mat-elevation-z4" (click)="openMapView();">
            <div style="padding: 4px;">
              {{'SHIPMENT_DASHBOARD.mapView' | translate}}
            </div>
          </div>
          
          <!-- <div class="ganttView mat-elevation-z4" (click)="openGanttDashboard();">
                      <div style="padding: 4px;">
                        {{'SHIPMENT_DASHBOARD.ganttLabel' | translate}}
                      </div>
                    </div> -->
        </div>
        <div class="buttons">
          <div class="mapView mat-elevation-z4" (click)="getCarrierInvoiceDetails();">
            <div style="padding: 4px;">
              {{'SHIPMENT_DASHBOARD.createInvoice' | translate}}
            </div>
          </div>
        </div>
        <div class="buttons tooltip">
          <div class="mapView mat-elevation-z4" (click)="selectShip = !selectShip" [ngClass]="{'buttonSelected': selectShip }">
            <div style="padding: 4px;">
              {{'SHIPMENT_DASHBOARD.selectShipments' | translate}} ({{selectedShipments.length}})
            </div>
          </div>
          <div *ngIf="selectedDONumbers.length > 0" class="tooltiptext">
            <div class="header">
              Selected DO Numbers: 
            </div>
            <div class="do_numbers_body">
              {{ getSelectedDONumbers() }}
            </div>
           
          </div>
        </div>

        <div class="refresh" (click)="paginator.pageIndex = 0;searchTerm = '';getShipments();clearSelection();"><i
            class="material-icons">refresh</i></div>

      </div>
      
    </div>

    <div class="advancedSearchSection" *ngIf="showAdvanceSearch">
      <div class="search">
        <div class="orgSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.organization' | translate}}
          </div>
          <div class="input">
            <mat-select class="inputSelect" [ngClass]="{'disabled': disableOrganization }"
              [disabled]="disableOrganization" [(ngModel)]="selectedOrganisation" style="color: #fff;"
              (selectionChange)="selectOrganization(selectedOrganisation);getFilters();">
              <mat-option *ngFor="let org of organizations" [value]="org" (click)="disableShipper = true;">
                {{org.name}}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="orgSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.shipper' | translate}}
          </div>
          <div class="input">
            <mat-select class="inputSelect" [ngClass]="{'disabled': disableShipper }" [disabled]="disableShipper"
              [(ngModel)]="selectedShipper" style="color: #fff;">
              <mat-option *ngFor="let ship of shippers" [value]="ship"
                (click)="disableOrganization=true; selectShipper(ship);">
                {{ship.name}}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="orgSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.material' | translate}}
          </div>
          <div class="input">
            <mat-select multiple class="inputSelect" [(ngModel)]="selectedMaterials" style="color: #fff;">
              <mat-option *ngFor="let mat of materialsArray" [value]="mat" (onSelectionChange)="selectMaterial(mat);">
                {{mat.name}}
              </mat-option>
            </mat-select>
          </div>
        </div>

        <div class="invoiceSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.invoice' | translate}}
          </div>
          <div class="input">
            <input type="text" [(ngModel)]="invoiceNo">
          </div>
        </div>
        <div class="invoiceSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.lrNo' | translate}}
          </div>
          <div class="input">
            <input type="text" [(ngModel)]="lrNumber">
          </div>
        </div>
        <div class="invoiceSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.shipperIn' | translate}}
          </div>
          <div class="input">
            <input type="text" [(ngModel)]="sinNumber">
          </div>
        </div>
      </div>
      <div class="search">
        <div class="orgSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.pick' | translate}}
          </div>
          <div class="input">
            <mat-select class="inputSelect" multiple [(ngModel)]="selectedPickups" style="color: #fff;">
              <input class="searchInput" [(ngModel)]="filterFrom" style="background-color: #fff;
              height: 100%;
              border: solid 1px #e3e3e3;
              width: 95%;
              margin: 2%;
              border-radius: 4px;">
              <mat-option *ngFor="let mat of locationsArray| search:filterFrom:'loc'" [value]="mat"
                (selectedValueChange)="selectLocation(mat);">
                <span style="font-weight: bold;">{{mat.name}}</span> - {{mat.area}}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="orgSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.drop' | translate}}
          </div>
          <div class="input">
            <mat-select class="inputSelect" multiple [(ngModel)]="selectedDeliveries" style="color: #fff;">
              <input class="searchInput" [(ngModel)]="filterTo" style="background-color: #fff;
              height: 100%;
              border: solid 1px #e3e3e3;
              width: 95%;
              margin: 2%;
              border-radius: 4px;">
              <mat-option *ngFor="let mat of locationsArray| search:filterTo:'loc'" [value]="mat"
                (selectedValueChange)="selectLocation(mat, 'drops');">
                <span style="font-weight: bold;">{{mat.name}}</span> - {{mat.area}}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="orgSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.invoiceStatus' | translate}}
          </div>
          <div class="input">
            <mat-select class="inputSelect" [(ngModel)]="selectedStatus" style="color: #fff;"
              (selectionChange)="selectStatus(status);getFilters();">
              <mat-option *ngFor="let status of statusArray" [value]="status.value">
                {{status.name}}
              </mat-option>
            </mat-select>
          </div>
        </div>
        <div class="fromSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.from' | translate}}
          </div>
          <div class="input">
            <input type="text" style="width: 40%;" class="inputField" placeholder="Date" [(ngModel)]="fromDateString"
              (click)="fromDateInput.open()" [matDatepicker]="fromDateInput" [max]="maxDateFrom" />
            <mat-datepicker #fromDateInput (closed)="setFromDate(fromDateString)"></mat-datepicker>
            <span class="material-icons dateIcon">
              date_range
            </span>
          </div>
        </div>
        <div class="toSection">
          <div class="label">
            {{'SHIPMENT_DASHBOARD.to' | translate}}
          </div>
          <div class="input">
            <input type="text" style="width: 40%;" class="inputField" placeholder="Date" [(ngModel)]="toDateString"
              (click)="toDateInput.open()" [matDatepicker]="toDateInput" [max]="maxDateTo" [min]="minDateTo" />
            <mat-datepicker #toDateInput (closed)="setToDate(toDateString)"></mat-datepicker>
            <span class="material-icons dateIcon">
              date_range
            </span>
          </div>
        </div>
        <div class="submitButton" (click)=" getShipments();submitSearch();">
          <div class="button">
            {{'SHIPMENT_DASHBOARD.submit' | translate}}
          </div>
        </div>
        <div class="submitButtonClear" (click)="clear()">
          <div class="button">
            {{'SHIPMENT_DASHBOARD.clear' | translate}}
          </div>
        </div>
      </div>
    </div>

    <div class="table">
      <div class="tabs">
        <div class="tab" (click)="changeTab('all')" [ngClass]="{ active: selectedType == 'all' }"
          >
          {{'SHIPMENT_DASHBOARD.all' | translate}}
        </div>
        <div class="tab"
          [ngClass]="{ active: selectedType == 'managedBy' }" (click)="changeTab('managedBy')">
          {{'SHIPMENT_DASHBOARD.managed' | translate}}
        </div>
      </div>

      <mat-paginator #paginatorTop (page)="handlePageTop($event)" showFirstLastButtons
        [length]="(shipments)? totalShipments:0" [pageSizeOptions]="[5, 10, 25, 100,200]" [pageSize]="25"
        style="padding-bottom: 0px; "></mat-paginator>

      <table mat-table  [dataSource]="shipments" matSort (matSortChange)="sortShipmentData($event)">

        <ng-container matColumnDef="sin">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
            <h3>
              {{'SHIPMENT_DASHBOARD.shipperIn' | translate}}
            </h3>
          </th>
          <td mat-cell *matCellDef="let element">
            {{element.sin}}
            <div class="status" *ngIf="element.status == 'Completed'">
              <div>
                <img src="assets/status-Completed.svg" alt="Completed" height="15px">
              </div>
              <div style="color:#188c06; padding:0px 5px">{{'SHIPMENT_DASHBOARD.completed' | translate}}</div>
            </div>
            <div class="status" *ngIf="element.status == 'Pending'">
              <div>
                <img src="assets/status-Pending.svg" alt="Pending" height="15px">
              </div>
              <div style="color:#1584ee; padding:0px 5px">{{'SHIPMENT_DASHBOARD.pending' | translate}}</div>
            </div>
            <div class="status" *ngIf="element.status == 'In Transit'">
              <div>
                <img src="assets/status-InTransit.svg" alt="In Transit" height="15px">
              </div>
              <div style="color:#cb7532; padding:0px 5px">{{'SHIPMENT_DASHBOARD.inTransit' | translate}}</div>
            </div>
            <div class="status" *ngIf="element.status == 'Cancelled'">
              <div>
                <img src="assets/status-Cancelled.svg" alt="Cancelled" height="15px">
              </div>
              <div style="color:#d2191c; padding:0px 5px">{{'SHIPMENT_DASHBOARD.cancelled' | translate}}</div>
            </div>
            <div class="status" *ngIf="element.status == 'Assigned'">
              <div>
                <img src="assets/status-Assigned.svg" alt="Assigned" height="15px">
              </div>
              <div style="color:#063e84; padding:0px 5px">{{'SHIPMENT_DASHBOARD.assigned' | translate}}</div>
            </div>
            <div class="status" *ngIf="element.status == 'Towards Pickup'">
              <div>
                <img src="assets/towards-pickup.svg" alt="Assigned" height="17px">
              </div>
              <div style="color:#164cb3; padding:0px 5px">{{'SHIPMENT_DASHBOARD.towards_pickup' | translate}}</div>
            </div>
            <div class="status" *ngIf="element.status == 'At Pickup'">
              <div>
                <img src="assets/at-pickup.svg" alt="Assigned" height="16px">
              </div>
              <div style="color:#ed4747; padding:0px 5px">{{'SHIPMENT_DASHBOARD.at_pickup' | translate}}</div>
            </div>
            <div class="status" *ngIf="element.status == 'At Delivery'">
              <div>
                <img src="assets/at-delivery.svg" alt="Assigned" height="15px">
              </div>
              <div style="color:#c87e80; padding:0px 5px">{{'SHIPMENT_DASHBOARD.at_delivery' | translate}}</div>
            </div>
            <div class="status" *ngIf="element.status == 'Accepted'">
              <div>
                <img src="assets/Accepted.svg" alt="Accepted" height="15px">
              </div>
              <div style="color:#188c06; padding:0px 5px">{{'SHIPMENT_DASHBOARD.accepted' | translate}}</div>
            </div>
            <div class="status" *ngIf="element.status == 'About to Reach'">
              <div>
                <img src="assets/at-delivery.svg" alt="About to Reach" height="15px">
              </div>
              <div style="color:#231c8a; padding:0px 5px">{{'SHIPMENT_DASHBOARD.about_to_reach' | translate}}</div>
            </div>

            <span (click)="$event.stopPropagation();">
              <a href="{{this.trackerUrl + element.unique_code}}" target="_blank">
                <img class="flagImg" *ngIf="element.tripTracker" src="assets/green-SIM.svg" alt=""
                  title="{{'SHIPMENT_DASHBOARD.yesConsent' | translate}}">
                <img class="flagImg" *ngIf="!element.tripTracker" src="assets/red-SIM.svg" alt=""
                  title="{{'SHIPMENT_DASHBOARD.noConsent' | translate}}">
              </a>
            </span>
            <span>
              <img class="flagImg" *ngIf="element.whatsApp.isEpodRequested && !element.whatsApp.isEpodReceived"
                src="assets/red-Request.svg" alt="" title="{{'SHIPMENT_DASHBOARD.yesEpod' | translate}}">
            </span>
            <span>
              <img class="flagImg" *ngIf="element.whatsApp.isEpodReceived" src="assets/green-Request.svg" alt=""
                title="{{'SHIPMENT_DASHBOARD.noEpod' | translate}}">
            </span>
            <span *ngIf="element.delay_deduction && element.delay_deduction > 0">
              <img class="flagImg" src="assets/Delay.svg" alt=""
                (click)="openShipmentDelayDialog(element);$event.stopPropagation()"
                title="{{'SHIPMENT_DASHBOARD.delayed_shipment' | translate}}">
            </span>
            <span>
              <img src="assets/Gps (2).svg" *ngIf="element.gpsVehicle" alt="" class="gps_track" title="GPS Vehicle"
                height="15px" />
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="doNumbers">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
            <h3>
              {{'SHIPMENT_DASHBOARD.doNumber' | translate}}
            </h3>
          </th>
          <td mat-cell *matCellDef="let element">{{element.doNumbers}}</td>
        </ng-container>
        <ng-container matColumnDef="pickup_drop">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
            <h3>
              {{'SHIPMENT_DASHBOARD.pickup_drop' | translate}}
            </h3>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="loc-tabs">
              <div class="loc-tile">
                <div class="icon" *ngFor="let pick of element.from; let i = index">
                  <span>
                    <label class="pick-icon">P{{i+1}}</label>
                  </span>
                  <span class="location">
                    {{pick.location.name}} - {{pick.location.city}} {{pick.others && '(Invoice ' + pick.others.invoice_status.toLowerCase() + ')'}}
                  </span>
                </div>
              </div>
              <div class="loc-tile">
                <div class="icon" *ngFor="let pick of element.to; let i = index">
                  <span>
                    <label class="drop-icon">D{{i+1}}</label>
                  </span>
                  <span class="location">
                    {{pick.location.name}} - {{pick.location.city}}
                  </span>
                </div>

              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="date_time">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
            <h3 style="margin: 5px;">
              {{'SHIPMENT_DASHBOARD.date_time' | translate}}
            </h3>
            <span style="color:#9a9a9a">
              {{'SHIPMENT_DASHBOARD.date_time_subtitle' | translate}}
            </span>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="loc-tabs">
              <div class="loc-tile">
                <span class="icon">
                  <label class="pick-icon">P1</label>
                </span>
                <!-- <img class="logo" src="assets/icon-plus.svg" alt=""> -->
                <span class="location">
                  {{element.scheduledDate}}
                </span>
              </div>
              <div class="loc-tile">
                <span class="icon">
                  <label class="drop-icon">D{{element.drop_num}}</label>
                </span>
                <!-- <img class="logo" src="assets/icon-plus.svg" alt=""> -->
                <span class="location">
                  {{element.scheduledDeliveryDate}}
                </span>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="vehicle_details">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader"
            style="width: 15% !important; padding: 0% 1%;">
            <span>
              <input type="text"  [placeholder]="'SHIPMENT_DASHBOARD.vehicle_details' | translate" [(ngModel)]="vehicle_no"
                (keyup)="vehicleMobileSearch()" (click)="stopProp($event)" class="input_search" />

            </span>
            <!-- <h3 style="margin: 5px;">
              {{'SHIPMENT_DASHBOARD.vehicle_details' | translate}}
            </h3> -->
            <span style="color:#9a9a9a">({{'SHIPMENT_DASHBOARD.requested' | translate}} /
              {{'SHIPMENT_DASHBOARD.assigned' | translate}})</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <div>
              {{element.vehicleNumber}}
            </div>
            <div class="sub">
              {{element.reqVehicleType}} / {{element.vehicleType}}
            </div>
            <!-- <div>
              <span> {{'SHIPMENT_DASHBOARD.requested' | translate}}: </span>{{element.reqVehicleType}}
            </div>
            <div style="margin-top: 5px;">
              <span> {{'SHIPMENT_DASHBOARD.assigned' | translate}}: </span>{{element.vehicleType}}
            </div> -->
            <div>
              <span *ngFor=" let trip of element.trip_tracker.methods" (click)="$event.stopPropagation()">
                <span class="sim_tracking" *ngIf="trip == 'SIM'" (click)="downloadLocHistory('SIM',element._id)"><img
                    src="assets/simtracking (2).svg" style="width: 14px;" alt="" title="Sim Tracker"> </span>
                <span class="sim_tracking" *ngIf="trip == 'APP'" (click)="downloadLocHistory('APP',element._id)"> <img
                    src="assets/mobile (2).svg" alt="" class="mobile" title="Mobile Tracker">
                </span>
                <span class="sim_tracking" *ngIf="trip == 'GPS'" (click)="downloadLocHistory('GPS',element._id)"> <img
                    src="assets/Gps (2).svg" alt="" class="gps_track" title="GPS Tracker"> </span>
              </span>
            </div>

          </td>
        </ng-container>

        <ng-container matColumnDef="driver">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <span>
              {{'SHIPMENT_DASHBOARD.driver' | translate}}
            </span>
            <span>
              <input type="number" min="0" [placeholder]="'SHIPMENT_DASHBOARD.phone_number' | translate" [(ngModel)]="mobile"
                (keyup)="vehicleMobileSearch()" (click)="stopProp($event)" class="input_search" />
            </span>
          </th>
          <td mat-cell *matCellDef="let element">
            <div>
              {{element.driverName}}
            </div>
            <div class="sub">
              {{element.driverMobile}}<span *ngIf="element.simTrackingCarrier"> - {{element.simTrackingCarrier}}</span>
              <br>
              <sup class="notAccepted"
                *ngIf="element.notAccepted && element.driverName != '--'">{{'SHIPMENT_DASHBOARD.notAccepted' |
                translate}}</sup>

            </div>
            <div class="consent" *ngIf="showTracking">
              <img class="flagImg" *ngIf="element.showGreenConsent" src="assets/driver_consent_yes.svg" alt=""
                title="{{'SHIPMENT_DASHBOARD.yesSimConsent' | translate}}">
              <img class="flagImg" *ngIf="element.showRedConsent" src="assets/driver_consent_no.svg" alt=""
                title="{{'SHIPMENT_DASHBOARD.noSimConsent' | translate}}">
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="distance">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader" style="width: 10% !important;">
            <h3 style="margin: 5px;">
              {{'SHIPMENT_DASHBOARD.distance' | translate}}
            </h3>
            <span style="color:#9a9a9a">(Covered / Remaining)</span>
          </th>
          <td mat-cell *matCellDef="let element">
            <div>
              {{element.coveredDistance}} / {{element.remainingDistance}}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="freight" style="width:100px">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader" style="width: 8% !important;">
            <h3 style="margin: 5px;">
              {{'SHIPMENT_DASHBOARD.freight_amount' | translate}} ({{symbol}})
            </h3>
          </th>
          <td mat-cell *matCellDef="let element">
            <div>
              {{ element.freight ? (element.freight | number) : '--' }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="material">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
            <h3>
              {{'SHIPMENT_DASHBOARD.material' | translate}}
            </h3>
          </th>
          <td mat-cell *matCellDef="let element">
            <span *ngFor="let item of element.material; let i=index">
              {{item.name}}
              <span *ngIf="(element.material.length > 1) && (i != element.material.length-1)">, </span>
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="customHeader">
            <h3>
              {{'SHIPMENT_DASHBOARD.actions' | translate}}
            </h3>
          </th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation();">
            <div class="actionBtn">
              <div class="button">
                <mat-select [placeholder]="'SHIPMENT_DASHBOARD.actions' | translate">
                  <mat-option (click)="openShipmentDetails(element);">
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-view.svg" alt="">
                    {{'SHIPMENT_DASHBOARD.view' | translate}}
                  </mat-option>
                  <!-- <mat-option [disabled]="true">
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-edit.svg" alt="">  {{'SHIPMENT_DASHBOARD.edit' | translate}}
                            </mat-option> -->
                  <!-- <mat-option [disabled]="true">
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/icon-cancel-red.svg" alt="">  {{'SHIPMENT_DASHBOARD.cancel' | translate}}
                            </mat-option> -->
                  <!-- <mat-option >
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/Assign.svg" alt="">  {{'SHIPMENT_DASHBOARD.assignDriver' | translate}}
                            </mat-option> -->
                  <mat-option *ngIf="(element.status != 'Completed' && element.status != 'Assigned' && element.status != 'Cancelled')"
                    (click)="(element.status != 'Completed' && element.status != 'Assigned' && element.status != 'Cancelled') ? openSubscribe(element) : '';"
                    [disabled]="element.status == 'Completed' || element.status == 'Assigned' || element.status == 'Cancelled'">
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/tracking.svg" alt="">
                    {{'SHIPMENT_DASHBOARD.tracking' | translate}}
                  </mat-option>
                  <mat-option
                    [disabled]="((element.status != 'Completed' && element.status != 'Cancelled') || element.disableGenerateInvoice || isCarrierShipment)"
                    (click)="((element.status == 'Completed' || element.status == 'Cancelled') && !element.disableGenerateInvoice && !isCarrierShipment) ? generateFreight(element) : ''">
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/generate.svg" alt="">
                    {{'SHIPMENT_DASHBOARD.generate_bill' | translate}}
                  </mat-option>
                  <mat-option  *ngIf="(element.status != 'Completed' && element.status != 'Assigned' && element.status != 'Cancelled')"
                    (click)="(element.status != 'Completed' && element.status !='Cancelled') ? warningDialog(element) : ';'">
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/Assign.svg" alt="">
                    {{(element.driverName != '--') ? ('SHIPMENT_DASHBOARD.reassignDriver' | translate) :
                    ('SHIPMENT_DASHBOARD.assignDriver' | translate)}}
                  </mat-option>
                  <!-- <mat-option>
                              <img style="width: 16px;position: relative;top: 3px;" src="assets/free_driver.svg" alt="">  {{'SHIPMENT_DASHBOARD.freeDriver' | translate}}
                            </mat-option> -->
                  <mat-option *ngIf="(element.status != 'Completed' && element.status != 'Assigned' && element.status != 'Cancelled') && !isJSPL"
                    (click)="element.status != 'Completed' && element.status != 'Cancelled' ? completeShipment(element,'complete') : '';">
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/Completed.svg" alt="">
                    {{'SHIPMENT_DASHBOARD.completeShipment' | translate}}
                  </mat-option>
                  <mat-option (click)="addShortages(element)" [disabled]="(element.status != 'Completed')">
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">
                    Add Received Quantity
                  </mat-option>
                  <mat-option (click)="getShipmentDetails(element)">
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">
                    View Epods
                  </mat-option>
                  <mat-option (click)="openMwgDialg(element)" >
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">
                    Request MWG-A
                  </mat-option>
                  <mat-option (click)="openOdcDialg(element)" >
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">
                    Request ODC
                  </mat-option>
                  <!-- <mat-option (click)="openPullFreightDialg(element)" >
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">
                    {{'SHIPMENT_DASHBOARD.pullFreight' | translate}}
                  </mat-option> -->
                  <mat-option (click)="openshiftShipmentsDialg(element)" *ngIf="element.shipper_parent_name === 'JSPL' || element.shipper_parent_name === 'JSP' || element.shipper_parent_name === 'JSPL Angul'">
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">
                    {{'SHIPMENT_DASHBOARD.shiftShipments' | translate}}
                  </mat-option>   

                  <!-- <mat-option (click)="addShortages(element, 1)" >
                    <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">
                    {{'SHIPMENT_DASHBOARD.changeInvoiceType' | translate}}
                  </mat-option> -->
                  <mat-option (click)="updateFreightNew(element)">
                    <img src="assets\updateFreight.svg" alt="" class="icon" style="width: 16px; position: relative; top: 3px" />
                    {{ "SHIPMENT_DASHBOARD.updateFreightNew" | translate }}
                  </mat-option>

                  <mat-option (click)="openMissedEventDialog(element)"*ngIf="element.shipper_parent_name === 'JSPL' || element.shipper_parent_name === 'JSP' || element.shipper_parent_name === 'JSPL Angul'">
                    <img src="assets/tracking.svg"  alt="" class="icon" style="width: 16px; position: relative; top: 3px" />
                    {{ "SHIPMENT_DASHBOARD.missedEvent" | translate }}
                  </mat-option>
                  <mat-option 
                  (click)="$event.stopPropagation();share(element);">
                  <img style="width: 16px;position: relative;top: 3px;" src="assets/share.svg" alt="">
                  {{'SHIPMENT_DASHBOARD.share' | translate}}
                </mat-option>
                <mat-option 
                  (click)="$event.stopPropagation();sendEmail(element);">
                  <img style="width: 16px;position: relative;top: 3px;" src="assets/mailround.svg" alt="">
                  {{'SHIPMENT_DASHBOARD.mail' | translate}}
                </mat-option>
                <mat-option (click)="openShipmentDetails(element, 3)">
                  <img style="width: 16px;position: relative;top: 3px;" src="assets/upload.svg" alt="">
                  {{'SHIPMENT_DASHBOARD.uploadEpod' | translate}}
                </mat-option>
                <mat-option (click)="openShipmentDetails(element, 3)">
                  <img style="width: 16px;position: relative;top: 3px;" src="assets/request-ePOD.svg" alt="">
                  {{'SHIPMENT_DASHBOARD.requestEpod' | translate}}
                  </mat-option>
                  
                </mat-select>
              </div>
            </div>

          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" (click)="selectShip ? selectShipments(row) : openShipmentDetails(row);"
          [ngClass]="{ highlightRow: (shipmentDetails) ? row._id == shipmentDetails._id: selectShip ? selectedShipments.includes(row._id) : false}"></tr>
      </table>
      
        <mat-paginator #paginatorBottom (page)="handlePageBottom($event)" showFirstLastButtons
        [length]="(shipments)? totalShipments:0" [pageSizeOptions]="[5, 10, 25, 100,200]" [pageSize]="25">
      </mat-paginator>

      <!-- <ng-template #noOrders>
        <div class="noOrders">
          {{'SHIPMENT_DASHBOARD.noShip' | translate}}
        </div>
      </ng-template> -->
      <div class="noOrders" *ngIf="shipmentsArray.length == 0">
        {{ "SHIPMENT_DASHBOARD.noShip" | translate }}
      </div>
    </div>
  </div>
</div>
<ng-template #warning>
  <div class="dialogMain">
    <div class="section">
      <div class="header">
        <div class="label">
          {{'SHIPMENT_DASHBOARD.re_assign' | translate}}<i class="material-icons"
            (click)="warningRef.close(false);">clear</i>
        </div>
      </div>
      <div class="text">
        {{'SHIPMENT_DASHBOARD.warningText' | translate}}
        <div class="reassign_radio_sec">
          <p>
            <input type="radio" id="test1" name="radio-group" checked [(ngModel)]="re_assign_type" value="driver">
            <label for="test1">{{'SHIPMENT_DASHBOARD.re_assign_driver' | translate}}</label>
          </p>
          <p class="reassign_radio_btn">
            <input type="radio" id="test2" name="radio-group" [(ngModel)]="re_assign_type" value="vehicle">
            <label for="test2">{{'SHIPMENT_DASHBOARD.re_assign_vehicle' | translate}}</label>
          </p>
          <p class="reassign_radio_btn">
            <input type="radio" id="test3" name="radio-group" [(ngModel)]="re_assign_type" value="both">
            <label for="test3">{{'SHIPMENT_DASHBOARD.both_driver_vehicle' | translate}}</label>
          </p>
        </div>
      </div>
      <div class="submitButton">
        <div class="button" (click)="warningRef.close(true);">
          {{'SHIPMENT_DASHBOARD.submit' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #acceptDialog>
  <div class="dialogMain">
    <div class="section">
      <div class="header">
        <div class="label">
          {{'SHIPMENT_DASHBOARD.accept' | translate}}<i class="material-icons"
            (click)="acceptRef.close(false);">clear</i>
        </div>
      </div>
      <div class="text">
        {{'SHIPMENT_DASHBOARD.acceptText' | translate}}
      </div>
      <div class="submitButton">
        <div class="button" (click)="acceptRef.close(true);">
          {{'SHIPMENT_DASHBOARD.ok' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #delayedShipment>
  <div class="delayDialog">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="header">
      {{'SHIPMENT_DASHBOARD.delayed_shipment' | translate}}
      <i class="material-icons" (click)="delayedShipmentRef.close(false);">
        clear
      </i>
    </div>
    <div class="section">
      <div class="text">
        {{'SHIPMENT_DASHBOARD.delay_text' | translate}}
      </div>
      <div class="penalty_amount">
        {{'SHIPMENT_DASHBOARD.penalty_amount' | translate}} : {{shipmentDelayData.penalty}}
      </div>
      <div class="reasonBox">
        <textarea [required]="shipmentDelayData.reason" [placeholder]=" 'SHIPMENT_DASHBOARD.reason_waive' | translate "
          autofocus="false" [(ngModel)]="shipmentDelayData.reason"> </textarea>
      </div>
    </div>

    <div class="submitButton">
      <div class="button right-float" (click)="requestWaiveOff()" *ngIf="!shipmentDelayData.status">
        {{'SHIPMENT_DASHBOARD.waive_off' | translate}}
      </div>
      <div class="button left-float" (click)="delayedShipmentRef.close();" *ngIf="!shipmentDelayData.status">
        {{'SHIPMENT_DASHBOARD.cancel' | translate}}
      </div>
      <div class="disabled" *ngIf="shipmentDelayData && shipmentDelayData.status == 'PENDING'">
        {{'SHIPMENT_DASHBOARD.requested_already' | translate}}
      </div>
      <div class="green" *ngIf="shipmentDelayData && shipmentDelayData.status == 'APPROVED'">
        {{'SHIPMENT_DASHBOARD.approved' | translate}}
      </div>
    </div>
  </div>
</ng-template>

<ng-template #plantCodeDialog>
  <div class="plantMain">
    <div class="section">
      <div class="header">
        <div class="label">
          Select Plant Code
        </div>
        <div class="close">
          <button mat-icon-button class="close-button" [mat-dialog-close]="true">
            <img src="assets/popup_close_icon.svg" alt="">
          </button>
        </div>
      </div>
      <div class="body">
        <div class="inputRow">
          <div class="inputContainer">
            <div class="label">

            </div>
            <div class="input">
              <mat-form-field>
                <mat-label>Plant Code</mat-label>
                <mat-select [(ngModel)]="selectedPlantCode">
                  <mat-option *ngFor="let p of plantMap" [value]="p.name" (onSelectionChange)="selectPlantCode($event, p)">
                    {{p.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="inputContainer">
            <div class="label">
          
            </div>
            <div class="input" *ngIf="showStatus">
              <mat-form-field>
                <mat-label>Status</mat-label>
                <mat-select [(ngModel)]="selectedPlantStatus">
                  <mat-option *ngFor="let s of statuses" [value]="s">
                    {{s}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="buttons">
          <div class="newButton" (click)="viewInvoices()">
            <div class="label">
              View Invoices
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mwgRequest>
  <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="closeModal();">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
  <div class="mwgRequestdialog">
    <div class="dialog_header">
      <div class="dialog_title">{{ 'Request MWG -A'| translate}}</div>
    </div>
    <div class="dialog_body">
      <div class="driverDetailsSec" >
       <div class="mwgContainer_new">
        <div class="left">
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px;"  [(ngModel)]="mwg.sin" [disabled]="true"/>
              <label class="did-floating-label">{{'SIN' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.material" [disabled]="true"/>
              <label class="did-floating-label">{{'Material' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.pickUp" [disabled]="true"/>
              <label class="did-floating-label">{{'Pickup Location' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.pickUpDate" [disabled]="true"/>
              <label class="did-floating-label">{{'Pickup Date & Time' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.shipper" [disabled]="true"/>
              <label class="did-floating-label">{{'Shipper' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.mwga" [disabled]="true"/>
              <label class="did-floating-label">{{'MWG-A (MT)' | translate}}</label>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px;" [(ngModel)]="mwg.vehicle" [disabled]="true"/>
              <label class="did-floating-label">{{'Vehicle No.' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.doNumber" [disabled]="true"/>
              <label class="did-floating-label">{{'DO No.' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.drop" [disabled]="true"/>
              <label class="did-floating-label">{{'Drop Location' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.loadedWeight"  [disabled]="true"/>
              <label class="did-floating-label">{{'Loaded Weight (MT)' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.vehicle_capacity" [disabled]="true"/>
              <label class="did-floating-label">{{'Vehicle Capacity (MT)' | translate}}</label>
            </div>
          </div>
          <div class="item">
            <div class="input did-floating-label-content">
              <input type="text" class="inputField did-floating-input" placeholder=" " style=" font-size: 16px;" [(ngModel)]="mwg.MWG" (keyup)="calculationMWG()"/>
              <label class="did-floating-label">{{'Minimum weight guarantee (MT)' | translate}}</label>
            </div>
          </div>
        </div>
       </div>
        
      </div>
    </div>
    
    <div class="dialog_footer">
      <div class="dialog_footer_btn" (click)="addMwg()">{{'REQUEST'| translate}}</div>
    </div>
  </div>
</ng-template>


<ng-template #odcRequest>
  <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="closeModal();">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
  <div class="odcRequestdialog">
    <div class="odc_dialog_header">
      <div class="dialog_title">{{ 'Request ODC'| translate}}</div>
      <div class="doNumber">DO No. - {{ odc_Do_number }}</div>
    </div>
    <div class="requestComments">
      <div class="comment">Why are you requesting the manual ODC</div>
      <div class="text"><input type="text" class="text" [(ngModel)]="odcTextInput" placeholder="Write your reason here..."></div>
    </div>
    <div class="upload_odc">
      <div class="container" appDnd (fileDropped)="onFileDropped($event)">
        <input type="file" #fileDropRef id="fileDropRef" (change)="fileBrowseHandler($event.target.files)"
            accept=".pdf" />
        <img src="assets/upload_icon.svg" alt="">
        <div class="info">
          {{'SHIPMENT_DASHBOARD.dragDrop' | translate}}
        </div>
        <div class="newButton" for="fileDropRef">
            <div class="label">
              {{'SHIPMENT_DASHBOARD.browseUpload' | translate}}
            </div>
        </div>
        <div class="note">
            {{'SHIPMENT_DASHBOARD.only' | translate}} <b>{{'SHIPMENT_DASHBOARD.pdf' | translate}}</b>
            {{'SHIPMENT_DASHBOARD.fileRestriction' | translate}}.
        </div>
      </div>
      <div class="filesList" *ngIf="files.length">
        <div class="singleFile">
          <div class="left">
            <div class="fileIcon">
              <img src="assets/csv_icon.svg" alt="">
            </div>
            <div class="info">
              <div class="name">
                {{ files[0]?.name }}
              </div>
              <div class="size">
                {{ formatBytes(files[0]?.size) }}
              </div>
              <!-- <app-progress [progress]="files[0]?.progress"></app-progress> -->
            </div>
          </div>
          <div class="delete" (click)="deleteFile(0)">
            <img src="assets/cancel_file_icon.svg" alt="">
          </div>
        </div>
      </div>
        <div class="noFilesChoosen">
          {{'SHIPMENT_DASHBOARD.noFileChosen' | translate}}
        </div>
    </div> 
    <div class="submit_odc_btn">
      <div class="submit_odc" (click)="upload();">
        {{'SHIPMENT_DASHBOARD.submit_odc' | translate}}
      </div>
    </div>
  </div>
</ng-template>

<!-- <ng-template #pullFreight>
  <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="closedialog();">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
  <div class="dialogPullFreight">
    <div class="dialog_header">
      <div class="dialog_title">{{'SHIPMENT_DASHBOARD.pullFreight' | translate}}</div>
    </div>
    <div class="dialog_body">
      <div class="driverDetailsSec" >
        <div class="mwgContainer">
          <div class="SearchDetailsSec">
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;"  [(ngModel)]="SIN"[disabled]="true"/>
                <label class="did-floating-label">{{'SIN' | translate}}</label>
              </div>
            </div>
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;" [(ngModel)]="vehicleNo"[disabled]="true"/>
                <label class="did-floating-label">{{'Vehicle No' | translate}}</label>
              </div>
            </div>
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;"  [(ngModel)]="pickupPull"[disabled]="true"/>
                <label class="did-floating-label">{{'Pickup Location' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="driverDetailsSec" >
        <div class="mwgContainer">
          <div class="SearchDetailsSec">
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;" [(ngModel)]="selectedDestination" [matAutocomplete]="matDelivery"/>
                <label class="did-floating-label">{{'Delivery Location' | translate}}</label>
                <mat-autocomplete #matDelivery="matAutocomplete" (optionSelected)='selectCarrierList($event.option.value)'>
                  <mat-option *ngFor="let car of destination | filter:selectedDestination" [value]="car">
                    <span>{{ car }}</span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;" [(ngModel)]="freightRate" />
                <label class="did-floating-label">{{'Freight Rate (₹)' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="driverDetailsSec" >
        <div class="invoice" >
          <div style="font-family: 'Inter'; color: #71747A; padding-top: 28px;">Invoice Number</div>
          <div style="font-family: 'Inter'; color: #71747A; padding-top: 8px; display: flex;">
          </div>
            <span style="font-family: 'Inter'; color: #71747A;">
              {{ invoiceNumbers }}
            </span>
        </div>
      </div>
    </div>
    <div class="dialog_footer">
      <div class="dialog_footer_btn" (click)="getpullFreight()">{{'PULL FREIGHT'| translate}}</div>
      <div class="dialog_footer_btn_1" (click)="pullFreightRef.close()" >{{'CLEAR'| translate}}</div>
    </div>
  </div>
</ng-template> -->

<ng-template #shiftshipments>
  <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="closeShiftdialog();">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
  <div class="dialogshiftshipments">
    <div class="dialog_header">
      <div class="dialog_title">{{'SHIPMENT_DASHBOARD.shiftShipments' | translate}}</div>
    </div>
    <div class="dialog_body">
      <div class="driverDetailsSec" >
        <div class="mwgContainer">
          <div class="SearchDetailsSec">
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;"  [(ngModel)]="shiftSin"[disabled]="true"/>
                <label class="did-floating-label">{{'SIN' | translate}}</label>
              </div>
            </div>
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;" [(ngModel)]="shiftVehicleNo"[disabled]="true"/>
                <label class="did-floating-label">{{'Vehicle No' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="driverDetailsSec" >
        <div class="mwgContainer">
          <div class="SearchDetailsSec">
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;" [(ngModel)]="shiftDonumbers"[disabled]="true"/>
                <label class="did-floating-label">{{'DO number' | translate}}</label>
              </div>
            </div>
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;" [(ngModel)]="selectedJsplPlantName" [matAutocomplete]="matDelivery"/>
                <label class="did-floating-label">{{'JSPL Plants' | translate}}</label>
                <mat-autocomplete #matDelivery="matAutocomplete" >
                  <mat-option *ngFor="let arr of shiftshippersArr.value" [value]="arr.name" (onSelectionChange)="onSelectOption(arr)">
                    <span>{{ arr.name }}</span>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog_footer">
      <div class="dialog_footer_btn" (click)="shiftShipments()">{{'Shift'| translate}}</div>
      <div class="dialog_footer_btn_1" (click)="closeShiftdialog()" >{{'Cancel'| translate}}</div>
    </div>
  </div>
</ng-template>

<ng-template #changeInvoiceType>
  <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="closeInvoiceTypedialog();">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
  <div class="dialogchangeType">
    <div class="dialog_header">
      <div class="dialog_title">{{'Update Invoice Type' | translate}}</div>
    </div>
    <div class="dialog_body">
      <div class="table">
        <div class="tableHeader">
            <div class="label">
                Invoices
            </div>
        </div>
        <div class="tableBody">
        <table mat-table [dataSource]="invoiceDataSource">
        
            <ng-container matColumnDef="sno">
                <th mat-header-cell *matHeaderCellDef>Slno</th>
                <td mat-cell *matCellDef="let element; let i = index"> {{i+1}} </td>

            </ng-container>

        
            <ng-container matColumnDef="invoice_type">
                <th mat-header-cell *matHeaderCellDef>Invoice Type</th>
                <td mat-cell *matCellDef="let element">
                  {{element.invoiceType}}
                </td>
            </ng-container>

            <ng-container matColumnDef="invoice">
              <th mat-header-cell *matHeaderCellDef>Invoice</th>
              <td mat-cell *matCellDef="let element">
                {{ element.invoice  }}
              </td>
          </ng-container>

            <!-- <ng-container matColumnDef="freightRate">
                <th mat-header-cell *matHeaderCellDef>Freight Rate (&#8377;)</th>
                <td mat-cell *matCellDef="let element">
                  {{element.finalFreightRate | numberFormat}}
                </td>
            </ng-container> -->

            <ng-container matColumnDef="shippedQuantity">
              <th mat-header-cell *matHeaderCellDef>Shipped Quantity (MT)</th>
              <td mat-cell *matCellDef="let element">
                {{ element.shippedQty }}
              </td>
          </ng-container>

            <ng-container matColumnDef="shippedNoOfPieces">
                <th mat-header-cell *matHeaderCellDef>Shipped No Of Pieces</th>
                <td mat-cell *matCellDef="let element">
                    {{element.shippedNop}}
                </td>
            </ng-container>

             <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Action</th>
              <td mat-cell *matCellDef="let element">
                <div class="newButton" style="color: #FFFFFFDE;" *ngIf="element.invoiceType === 'CT'" (click)="(element.invoiceType = 'PT'); changeType(element, 'PT')" >Mark as PT</div>
                <div class="newButton" style="color: #FFFFFFDE;" *ngIf="element.invoiceType === 'PT'" (click)="(element.invoiceType = 'CT'); changeType(element, 'CT')" >Mark as CT</div>

                <!-- <button>Mark as CT</button> -->

              </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="invoiceDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: invoiceDisplayedColumns;"></tr>
        </table>
        </div>

    </div>
    </div>
    <div class="dialog_footer">
      <div class="dialog_footer_btn" (click)="changeCtPt()">{{'Submit'| translate}}</div>
    </div>
  </div>
</ng-template>

<ng-template #missedEvent>
  <button mat-icon-button class="close-button" [mat-dialog-close]="true" (click)="closeMissedEvent();">
    <mat-icon class="close-icon">close</mat-icon>
  </button>
  <div class="dialogMissedEvent">
    <div class="dialog_header">
      <div class="dialog_title">Missed Events</div>
    </div>
    <div class="dialog_body">
      <div class="driverDetailsSec" >
        <div class="mwgContainer">
          <div class="SearchDetailsSec">
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;" [(ngModel)]="missedEvents" [matAutocomplete]="matDelivery"/>
                <label class="did-floating-label">{{'Missed Event' | translate}}</label>
                <mat-autocomplete #matDelivery="matAutocomplete" >
                  <mat-option *ngFor="let car of missed" [value]="car.name" (click)="selectedMissedEvent = car.value"> <span>{{ car.name }}</span> </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="driverDetailsSec">
        <div class="mwgContainer">
          <div class="SearchDetailsSec">
            <div class="item">
              <div class="input did-floating-label-content">
                <input type="text" class="inputField did-floating-input" placeholder=" "  style=" font-size: 16px; color: #42454E;" [(ngModel)]="misssedEventDoNumber"/>
                <label class="did-floating-label">{{'DO number' | translate}}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="driverDetailsSec">
        <div class="mwgContainer">
          <div class="SearchDetailsSec">
            <div class="SearchDetailsSec">
              <div class="item" style="width: 2460px;">
                <div class="input did-floating-label-content">
                  <div style="font-family: 'Inter'; padding-left: 8px; font-size: 10px; color: red;">
                    Do Number is Mandatory for IV 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog_footer">
      <div class="dialog_footer_btn" (click)="addMissedEvents()">{{'Submit'| translate}}</div>
    </div>
  </div>
</ng-template>